const pageLoader = () => {

    let tl;
    tl = gsap.timeline();
    tl.addLabel('start');

    let overlay = document.querySelector('.page-loader'),
        text = document.querySelector('.hero__text'),
        form = document.querySelector('.hero__form'),
        loader = document.querySelector('.page-loader__logo');

    tl.to(overlay, 1, {top: '100%', ease: Power4.easeInOut, delay: .3});
    tl.to(text, {autoAlpha: 1, x: 0, y: 0, ease: Power1.easeOut, duration: 0.4});
    tl.to(form, {autoAlpha: 1, x: 0, y: 0, ease: Power1.easeOut, duration: 0.4});
    tl.to(loader, .8, {y: '40', opacity: 0});


    document.addEventListener('DOMContentLoaded', function () {
        tl.play();
    });
}

pageLoader();